import { connect } from 'react-redux'
import { setTemperature, fetchRooms } from '../../store/cozy/duck'

import EditTemperatureSettingsComponent from './component'

const EditTemperatureSettingsComponentContainer = connect(
  // Map state to props
  (state) => ({
    user: state.user.user,
    rooms:state.cozy.rooms,
    setTemperatures: state.cozy.setTemperatures
  }),
  // Map actions to props
  {
  	setTemperature,
  	fetchRooms
  }
)(EditTemperatureSettingsComponent)

export default EditTemperatureSettingsComponentContainer




// WEBPACK FOOTER //
// ./src/views/EditTemperatureSettings/container.js